import App from './app/reducer';
import ThemeSwitcher from './themeSwitcher/reducer';
import LanguageSwitcher from './languageSwitcher/reducer';
import DevReducers from '../customApp/redux/reducers';
import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import deviceVersion from "../customApp/redux/deviceVersion/reducers"
const appReducer = combineReducers({
  App,
  ThemeSwitcher,
  LanguageSwitcher,
  ...DevReducers,
  router: routerReducer,
  deviceVersion
})

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }
  return appReducer(state, action)
}

export default rootReducer;
